// TODO: This could be moved to a ThemeProvider    
import { SyncStatus, GenerationStatus, JobStatus } from "./status";


export const statusColorSync = {
    [SyncStatus.NEW]: 'success',
    [SyncStatus.UPDATED]: 'processing',
    [SyncStatus.DELETED]: 'error',
};

export const statusColorGeneration = {
    [GenerationStatus.EMPTY]: 'default',
    [GenerationStatus.NEW]: 'success',
    [GenerationStatus.BLOCKED]: 'error',
    [GenerationStatus.APPROVED]: 'success',
    [GenerationStatus.OUTDATED]: 'warning',
    [GenerationStatus.GENERATED]: 'processing',
    [GenerationStatus.FAILED]: 'error',
    [GenerationStatus.GENERATING]: 'warning',
};

export const statusApprovedActionColor = '#0d9488';

export const statusColorJob = {
    [JobStatus.PENDING]: 'default',
    [JobStatus.IN_PROGRESS]: 'processing',
    [JobStatus.COMPLETED]: 'success',
    [JobStatus.FAILED]: 'error',
    [JobStatus.PARTIAL_SUCCESS]: 'warning',
    [JobStatus.CANCELLED]: 'default',
}
